var Tax = /** @class */ (function () {
    function Tax(props) {
        Object.assign(this, props);
    }
    return Tax;
}());
export { Tax };
export var TaxCategory = {
    Article: 'article',
    Customer: 'customer'
};
export var TaxType = {
    Percentage: 'percentage',
    Map: 'map'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Taxes/Model.ts
// module id = 136
// module chunks = 0